import React from 'react';
import config from '../config/config';

const ATTRIBUTION_TEXT = config.common.attribution;

/**
 * 著作権表示コンポーネント
 */
const CopyrightNotice = ({
  isFromKntr = false,
}) => {

  // kntrは別クラス
  const className = isFromKntr
    ? 'kntr-copyright-notice'
    : 'copyright-notice';

  return (
    <div
      className={className}
    >
      <span>{ATTRIBUTION_TEXT}</span>
    </div>
  );
};

export default CopyrightNotice;